import { parseSearchWith, stringifySearchWith } from "@tanstack/react-router";

// The router's default search parser runs `JSON.parse` over every value, and
// that rounds whatever a JS number can't hold: an 18-digit ad-platform id
// (`utm_id=120208123456789012`) comes out as `…010` — another campaign's id —
// and a redirect then writes the rounded value back into the URL.
//
// So a number JSON can't write back to the same characters (that id, `1.0`,
// `1e3`) is refused: throwing is how both factories are told to leave a value
// as the string it was, unquoted. Everything else behaves like the default,
// including a string such as `"42"`, which still round-trips as a string.
const parseSearchValue = (value: string): unknown => {
  const parsed: unknown = JSON.parse(value);
  if (typeof parsed === "number" && String(parsed) !== value)
    throw new Error("lossy number");
  return parsed;
};

export const parseSearch = parseSearchWith(parseSearchValue);

export const stringifySearch = stringifySearchWith(
  JSON.stringify,
  parseSearchValue,
);
